import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
const { processAlertMessage } = require('app_custom_mufe_revamp/accessibility/accessibilityHelper');

export const samples = {

    elements: {
        $cartWrapper: $('.js-cart')
    },

    selectors: {
        carousel: '.js-product-samples-carousel',
        cartDialog: '#cart-modal',
        samples: '.js-product-samples',
        checkbox: '.js-sample-checkbox',
        squirrellySamples: '#samples'
    },

    modifiers: {
        samplesFull: 'product-samples__swiper--full'
    },

    settings: {
        carouselParameters:
        {
            modules: [Navigation],
            slidesPerView: 2.6,
            spaceBetween: 12,
            navigation: {
                nextEl: '.js-product-samples-btn-next',
                prevEl: '.js-product-samples-btn-prev',
            },
            on: {
                slideChangeTransitionEnd(swiper) {
                    processAlertMessage('Showing sample images slide ' + (swiper.realIndex + 1), true);
                }
            }
        }
    },

    state: {
        isInitialized: false,
        cartAddUrl: null,
        cartRemoveUrl: null,
        numberOfSamples: null,
        swiperInstance: null,
        samples: []
    },

    init() {
        if ($(this.selectors.samples + ' :checked').length >= this.state.numberOfSamples) {
            $(this.selectors.carousel).addClass(this.modifiers.samplesFull);
        } else {
            $(this.selectors.carousel).removeClass(this.modifiers.samplesFull);
        }

        this.initCarousel();

        if (!this.state.isInitialized) {
            this.initEvents();
            this.state.cartAddUrl = this.elements.$cartWrapper.attr('data-cart-add-url');
            this.state.cartRemoveUrl = this.elements.$cartWrapper.attr('data-cart-remove-url');
            this.state.isInitialized = true;
        }

        if ($(this.selectors.samples + ' :checked').length > this.state.numberOfSamples) {
            this.state.samples.filter(sample => sample.isInCart).forEach(sample => {
                this.removeProductFromCart(sample.id, sample.pliUUID);
            });

            this.elements.$cartWrapper.trigger('cart-reset');
            return;
        }
    },

    initEvents() {
        $(this.selectors.checkbox).on('change', this.onCheckboxChange.bind(this));
    },

    initCarousel() {
        if (this.state.swiperInstance) {
            this.state.swiperInstance.destroy();
        }
        this.state.swiperInstance = new Swiper(this.selectors.carousel, this.settings.carouselParameters);
    },

    onCheckboxChange(e) {
        const input = e.target;
        const sampleId = input.value;
        const sampleUUID = $(input).attr('data-uuid');

        const isError = input.checked ? this.addProductToCart(sampleId) : this.removeProductFromCart(sampleId, sampleUUID);

        if (isError) {
            input.checked = !input.checked;
            return;
        }

        if ($(this.selectors.samples + ' :checked').length >= this.state.numberOfSamples) {
            $(this.selectors.carousel).addClass(this.modifiers.samplesFull);
        }else {
            $(this.selectors.carousel).removeClass(this.modifiers.samplesFull);
        }
    },

    addProductToCart(sampleId) {
        $.ajax({
            url: this.state.cartAddUrl,
            method: 'post',
            data: {
                pid: sampleId,
                quantity: 1
            },
            success: (data) => {
                if (data.error){
                    console.warn(data.message);
                    return false;
                }
                this.state.samples.find(sample => sample.id === sampleId).isInCart = true;
                return true;
            }
        });
    },

    removeProductFromCart(sampleId, sampleUUID) {
        $.ajax({
            url: this.state.cartRemoveUrl,
            method: 'get',
            data: {
                pid: sampleId,
                uuid: sampleUUID
            },
            success: () => {
                this.state.samples.find(sample => sample.id === sampleId).isInCart = false;
                return true;
            },
            error: (data) => {
                console.warn(data.message);
                return false;
            }
        });
    },

    renderSamples(cart) {
        if (cart?.samples) {
            const sampleIdsInCart = cart.items
                .filter(item => ['SAMPLE'].includes(item.CORE_ITEMTYPE))
                .map(item => item.id);

            cart.samples = cart.samples.map(sample => ({
                ...sample,
                isInCart: sampleIdsInCart.includes(sample.id)
            }));

            this.state.samples = cart.samples;
        }

        $(this.selectors.samples).morphBy({
            id: this.selectors.squirrellySamples,
            squirrellyOptions: {
                samples: this.state.samples,
                numberOfSamples: cart.numberOfSamples
            },
            morphDomOptions: {
                morph: true,
                childrenOnly: true
            }
        });

        this.state.numberOfSamples = cart.numberOfSamples;

        this.init();
    }
};
